import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailPassRestoreComponent } from '../password-retrieval/email-pass-restore/email-pass-restore.component';
import { BlockedBusinessModalComponent } from '../blocked-business-modal/blocked-business-modal.component';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'corporate-recovery-password-modal',
	template: require('./corporate-recovery-password-modal.component.html'),
})
export class CorporateRecoveryPasswordModalComponent implements OnInit {
	@Input() public isCorporate: boolean = false;
	@Input() blockedUser: boolean = false;
	@Input() isForgotPasswordClicked: boolean = false;
	public isRebrading = AppSettings.isRebrading;
	constructor(private modalService: NgbModal, public activeModal: NgbActiveModal) {}

	password: object[];

	closeModal(): void {
		this.activeModal.close();
	}

	ngOnInit() {
		this.password = [
			{
				name: 'unlock-email',
				isSelected: false,
				description: 'Ανάκτηση Password με email',
			},
			{
				name: 'unlock-personal',
				isSelected: false,
				description: 'Ανάκτηση Password από νόμιμο εκπρόσωπο.',
			},
		];
	}

	selectPackage(item: string): void {
		switch (item) {
			case 'unlock-email':
				this.activeModal.close();
				let modalRef = this.modalService.open(EmailPassRestoreComponent, {
					windowClass: 'modal-full',
				});
				modalRef.componentInstance.isCorporate = this.isCorporate;
				modalRef.componentInstance.hasBackBtn = false;
				break;
			case 'unlock-personal':
				this.toggleBlocked();

			default:
				break;
		}
	}

	public toggleBlocked() {
		this.activeModal.close();
		const modalRef = this.modalService.open(BlockedBusinessModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as BlockedBusinessModalComponent).blockedUser =
			this.blockedUser;
		(modalRef.componentInstance as BlockedBusinessModalComponent).isForgotPasswordClicked =
			this.isForgotPasswordClicked;
	}
}
